import {
  VarnishContext
} from "./chunk-BDRB3LP3.js";

// src/components/Content.tsx
import { Box, styled } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var InternalContent = styled(({ main, layout, bgcolor, ...rest }) => /* @__PURE__ */ jsx(Box, { component: main ? "main" : "div", ...rest }))`
    max-width: ${({ theme, layout }) => layout === "center-aligned" ? `${theme.breakpoints.values.lg}px` : null};
    width: 100%;
    ${({ layout }) => layout === "center-aligned" ? "margin: 0 auto;" : ""}
    padding: ${({ theme }) => theme.spacing(3)};
    word-wrap: break-word;
    word-break: break-word;
    hyphens: auto;

    // if the user passes a key to the color theme, use the mapped color,
    // else treat the string as a normal color string
    background: ${({ theme, bgcolor }) => (
  // We're playing it very safe here _just in case_
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  bgcolor ? theme.color[bgcolor] ? theme.color[bgcolor].hex : bgcolor : "none"
)};

    @media (max-width: ${({ theme }) => `${theme.breakpoints.values.sm}px`}) {
        padding: ${({ theme }) => theme.spacing(1.5)};
    }
`;
function Content({ children, className, ...basicProps }) {
  return /* @__PURE__ */ jsx(VarnishContext.Consumer, { children: ({ layout }) => /* @__PURE__ */ jsx(InternalContent, { layout, className, ...basicProps, children }) });
}
var Content_default = Content;

export {
  Content,
  Content_default
};
//# sourceMappingURL=chunk-WQQCTYOM.js.map